<template>
  <div>
    <GeoprocessingChart :chart-data="fakeResponse" title="Total Buffer" />
  </div>
</template>

<script>
import GeoprocessingChart from '../components/mapTools/geoprocessings/GeoprocessingChart.vue';


export default {
  components: {
    GeoprocessingChart
  },
  data() {
    return {
      fakeResponse: {
          "Total Buffer": [
            { radius: 1000, features_count: 2, percentage: 100 },
            { radius: 4000, features_count: 0, percentage: 0 },
          ],
        }
    };
  }
};
</script>
